export const colors = ['#000000', '#974366ff', '#6262c0ff', '#e12727ff'];
